import Game from '../../Game';
import { IGameState } from '../../State/Game/IGameState';
import { CrossPromoStatus, ShortcutStatus } from '../../State/User/UserActions';
import BaseUISystem from './BaseUISystem';
import ShopHUD from './HUD/ShopHUD';
import CrossPromoMenu from './Menu/CrossPromoMenu';
import CrossPromoHUD from './HUD/CrossPromoHUD';
import ErrorMenuHandler from './Menu/ErrorMenuHandler';
import ConfirmSignOutMenuHandler from './Menu/ConfirmSignOutMenuHandler';
import CreateShortcutMenu from './Menu/CreateShortcutMenu';
import LevelMenuHandler from './Menu/LevelMenuHandler';
import NoLivesMenuHandler from './Menu/NoLivesMenuHandler';
import PostcardMenuHandler from './Menu/PostcardMenuHandler';
import ReceiveCoinsFriendMenuHandler from './Menu/ReceiveCoinsFriendMenuHandler';
import ReceiveCoinsMenuHandler from './Menu/ReceiveCoinsMenuHandler';
import ReceivedLivesFriendMenuHandler from './Menu/ReceiveLivesFriendMenuHandler';
import ReceiveLivesMenuHandler from './Menu/ReceiveLivesMenuHandler';
import ReceiveMissionMenuHandler from './Menu/ReceiveMissionMenuHandler';
import ScoreBeatenMenuHandler from './Menu/ScoreBeatenMenuHandler';
import SendLivesMenuHandler from './Menu/SendLivesMenuHandler';
import SettingsMenuHandler from './Menu/SettingsMenuHandler';
import ShopMenuHandler from './Menu/ShopMenuHandler';
import SideMenuHandler from './Menu/SideMenuHandler';
import ThreeStarRewardMenuHandler from './Menu/ThreeStarRewardHandler';
import TravelMenuHandler from './Menu/TravelMenuHandler';
import WheelMenuHandler from './Menu/WheelMenuHandler';
import WorldHUDHandler from './HUD/WorldHUDHandler';
import WorldUnlockMenuHandler from './Menu/WorldUnlockMenuHandler';
import NoCoinsMenuHandler from './Menu/NoCoinsMenuHandler';
import ReceiveCardFriendMenuHandler from './Menu/ReceiveCardFriendMenuHandler';
import RateAppMenuHandler from './Menu/RateAppMenuHandler';
import ResolveDataConflictMenuHandler from './Menu/ResolveDataConflictMenuHandler';

export default class WorldUISystem extends BaseUISystem {
    public init(): void {
        const HUD = new WorldHUDHandler(this);

        this.handlers = [
            HUD,
            new SideMenuHandler(this),
            new LevelMenuHandler(this),
            new SettingsMenuHandler(this),
            new TravelMenuHandler(this),
            new WheelMenuHandler(this),
            new NoLivesMenuHandler(this),
            new ReceiveLivesMenuHandler(this),
            new SendLivesMenuHandler(this),
            new NoCoinsMenuHandler(this),
            new ReceiveCoinsMenuHandler(this),
            new WorldUnlockMenuHandler(this),
            new ScoreBeatenMenuHandler(this),
            new ThreeStarRewardMenuHandler(this),
            new ReceiveMissionMenuHandler(this),
            new ErrorMenuHandler(this),
            new ConfirmSignOutMenuHandler(this),
            new CreateShortcutMenu(this),
        ];

        const state = Game.state.getState();

        if (state.platform.IAPSupport) {
            this.handlers.push(new ShopMenuHandler(this));
            this.handlers.push(new ShopHUD(this));
        }

        if (state.userState.crossPromo === CrossPromoStatus.ENABLED) {
            this.handlers.push(new CrossPromoMenu(this));
            this.handlers.push(new CrossPromoHUD(this));
        }

        if (Game.sdk.driver.hasSocialFeaturesSupport()) {
            this.handlers.push(new PostcardMenuHandler(this));
        }

        if (hasUIQueued(state, 'receiveCardFriendMenu')) {
            this.handlers.push(new ReceiveCardFriendMenuHandler(this));
        }

        if (hasUIQueued(state, 'receiveLivesFriendMenu')) {
            this.handlers.push(new ReceivedLivesFriendMenuHandler(this));
        }

        if (hasUIQueued(state, 'receiveCoinsFriendMenu')) {
            this.handlers.push(new ReceiveCoinsFriendMenuHandler(this));
        }

        if (hasUIQueued(state, 'rateAppMenu')) {
            this.handlers.push(new RateAppMenuHandler(this));
        }

        if (hasUIQueued(state, 'resolveDataConflictMenu')) {
            this.handlers.push(new ResolveDataConflictMenuHandler(this));
        }

        if (
            Game.state.getState().userState.createShortcut ===
            ShortcutStatus.ENABLED
        ) {
            this.handlers.push(new CreateShortcutMenu(this));
        }
    }
}

function hasUIQueued(state: IGameState, popupID: string): boolean {
    return state.UIState.queue.find(task => task.popupID === popupID) !== null;
}
